import type { BulletListOptions } from '@tiptap/extension-bullet-list'
import BulletList from '@tiptap/extension-bullet-list'

export enum List {
  Bullet = 'bullet',
  Check = 'check',
}

export type BulletListOptionsExtended = BulletListOptions

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    bulletListExtended: {
      setBulletList: (type: List) => ReturnType
    }
  }
}

export const BulletListExtended = BulletList.extend<BulletListOptionsExtended, any>({
  addOptions() {
    return {
      ...this.parent?.(),
      type: [List.Bullet, List.Check],
    }
  },

  addAttributes() {
    return {
      ...this.parent?.(),
      type: {
        default: List.Bullet,
        rendered: false,
      },
    }
  },

  // Place for Check List
})

export default BulletListExtended
